export { errorMessage, formatCount, money } from '../../customers/common/customer-common'
export { currentYear, monthNames, parseDate } from '../../../utils/dates'
export { formatAmount, parseAmount, sanitizeDecimal } from '../../../utils/numbers'

export const GOALS_BACK_PATH = '/configuracion'
export const ALL_INSURERS = '-1'
export const ANNUAL = 'anual'
export const WHOLE_PORTFOLIO = 'todos'

export interface FormMessage {
    type: 'error' | 'success'
    message: string
}